export default "__VITE_ASSET__DCUiTfhj__"